import { Mappable } from '../../_shared/mappable.class';
import { Event } from './Event'

export class Cue5050 extends Mappable<Cue5050>  {

    cue5050Id: number;
   
    ticketIncrement: number;
    ticketsAvailable: number;
    minimumDisplayValue: number;
    startingPotSeed: number;
    potSeedingDurationSeconds: number;
    percentWinner: number;
    expensePercent: number;
    expenseCap: number;
    eventStartTime: string;
    winnerSelectTime: string;
    customWinnerSelectTime: string;

    event: Event;

    restrictState: boolean;
    restrictCity: boolean;
    pricingTiers: PricingTier[];
    ticketNumberPrefix: string;
    ticketNumberSuffix: string;
    useRandomNumbers: boolean;
    startingTicketNumber: number;

    winningTicket: Ticket;
    receiptInfo: ReceiptInfo;

}


export interface PricingTier  {
    cue5050PricingTierId: number;
    description: string;
    price: number;
    amount: number;
}

export interface Ticket  {
    ticketNumber: string;
    verified: boolean;
}

export class ReceiptInfo extends Mappable<ReceiptInfo> {
    header1: string;
    header2: string;
    subheader: string;
    vendorName: string;
    lineItems: [ { name: string; enabled: boolean; } ];
    quantity: string;
    total: string;
    ticketNumbers: string[];
    winnerSelectTime: string;
    winnerSelectDate: string;
    rulesText: string;
    footerHeader: string;
    footerText: string;
}

export class Cue5050DetailView extends Mappable<Cue5050DetailView> {
    eventName: string;
    eventCoordinator: string;
    beneficiary: string;
    startDate: Date
    endDate: Date;
    grossSales: number;
    cueFees: number;
    expenses: number;
    cardFees: number;
    totalPot: number;
    prizeTotal: number;
    payouts: any;
}